<template>
    <b-container class="card-presentation-container" >
        <Particles />
        <Card />
    </b-container>
</template>

<script>
import Particles from "@/components/Particles"
import Card from "@/components/CardPresentation"

export default {
    components: {
        Particles,
        Card
    }
}
</script>

<style>

</style>